class InsurancePlugin {
  constructor() {
    this.insurance_handle = 'natural-cotton-hanging-garment-dust-cover-lc-acc-org37';
    this.insurance_id = 45748133626035;
    this.insurance_selected = false;
    this.isProcessing = false;
    this.init();
  }

  async init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.setupInsurance();
      });
    } else {
      this.setupInsurance();
    }
  }

  async setupInsurance() {
    try {
      await this.syncToggleWithCart();
      this.bindEvents();
    } catch (error) {
      console.error('Error setting up laundry bag plugin:', error);
    }
  }

  async syncToggleWithCart() {
    try {
      const hasItem = await this.hasInsuranceProduct();
      this.insurance_selected = !!hasItem;
      this.updateToggleUI(this.insurance_selected);
    } catch (error) {
      console.error('Failed to sync toggle with cart:', error);
    }
  }

  updateToggleUI(isChecked) {
    const toggleInput = document.querySelector('.laundry-bag-toggle');
    const insuranceImage = document.querySelector('.insurance-checkbox-icon img');

    if (toggleInput) {
      toggleInput.checked = isChecked;
    }

    if (insuranceImage) {
      if (isChecked) {
        insuranceImage.classList.remove('not-check');
      } else {
        insuranceImage.classList.add('not-check');
      }
    }

    this.insurance_selected = isChecked;
  }

  getInsuranceConfig() {
    const toggleInput = document.querySelector('.laundry-bag-toggle');
    const wrapper = document.querySelector('.insurance-checkbox-wrapper');

    const handle = toggleInput?.dataset.handle || wrapper?.dataset.insuranceHandle || this.insurance_handle;
    const variantId = toggleInput?.dataset.variantId || wrapper?.dataset.insuranceVariantId || this.insurance_id;

    return { handle, variantId };
  }

  bindEvents() {
    const handleCartChange = this.debounce(async () => {
      await this.syncToggleWithCart();
    }, 500);

    document.addEventListener('on:cart:change', handleCartChange);
    document.addEventListener('on:cart:add', handleCartChange);

    document.addEventListener('change', async (e) => {
      const toggleInput = e.target.closest('.laundry-bag-toggle');
      if (!toggleInput) return;

      if (this.isProcessing) return;
      this.isProcessing = true;

      const isChecked = toggleInput.checked;
      this.insurance_selected = isChecked;

      try {
        const config = this.getInsuranceConfig();
        if (isChecked) {
          await this.addInsuranceToCart(config.variantId);
        } else {
          await this.removeInsuranceFromCart();
        }

        this.updateToggleUI(isChecked);

        document.dispatchEvent(
          new CustomEvent('on:cart:change', {
            bubbles: true,
            cancelable: false
          })
        );
      } catch (error) {
        console.error('Failed to update laundry bag in cart:', error);
        this.updateToggleUI(!isChecked);
      } finally {
        this.isProcessing = false;
      }
    });
  }

  debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }

  async addInsuranceToCart(variantId) {
    try {
      const existingItem = await this.hasInsuranceProduct();
      if (existingItem && existingItem.quantity >= 1) {
        return;
      }

      const formData = {
        items: [{
          id: variantId,
          quantity: 1
        }]
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        let errorBody = '';
        try { errorBody = JSON.stringify(await response.json()); } catch (_) {}
        throw new Error(`Failed to add laundry bag to cart (${response.status}): ${errorBody}`);
      }
    } catch (error) {
      console.error('Failed to add laundry bag:', error);
      throw error;
    }
  }

  async removeInsuranceFromCart() {
    try {
      const insuranceItem = await this.hasInsuranceProduct();
      if (!insuranceItem) return;

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: insuranceItem.key, quantity: 0 })
      });

      if (!response.ok) {
        throw new Error('Failed to remove laundry bag from cart');
      }
    } catch (error) {
      console.error('Failed to remove laundry bag:', error);
      throw error;
    }
  }

  async getCartData() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch cart data:', error);
      throw error;
    }
  }

  async hasInsuranceProduct() {
    const config = this.getInsuranceConfig();
    const cart = await this.getCartData();
    if (!config) return null;
    return cart.items.find(item => item.variant_id == config.variantId || item.handle === config.handle);
  }
}

window.insurancePlugin = new InsurancePlugin();